import React, { useState, useEffect } from 'react';
import AdminApi from './AdminApi';

const AdminRolePermissionEditPage = ({ clickChangeMenu, editingRole }) => {
    const [permissions, setPermissions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    // Human readable mapping for common permission codes
    const permissionLabels = {
        'ADMIN_PANEL': 'Truy cập trang Admin Panel',
        'PIXEL_ADMIN': 'Truy cập trang PixelAdmin',
        'CUSTOMIZATION': 'Truy cập trang Tùy chỉnh',
        'MENU_MANAGEMENT': 'Truy cập quản lý Menu',
        'EMAIL_MANAGEMENT': 'Truy cập quản lý Email',
        'USER_MANAGEMENT': 'Truy cập quản lý User',
        'SALES_INFO': 'Truy cập phần bán hàng',
        'HEADER_HTML': 'Header HTML'
    };

    const getLabel = (code) => permissionLabels[code] || code;

    useEffect(() => {
        if (editingRole) {
            fetchPermissions();
        }
    }, [editingRole]);

    const fetchPermissions = async () => {
        setIsLoading(true);
        try {
            const data = await AdminApi.getRolePermissions(editingRole.roleid);
            setPermissions(data || []);
        } catch (err) {
            console.error("Error fetching permissions:", err);
            setPermissions([]);
        } finally {
            setIsLoading(false);
        }
    };

    const handleToggle = (permissionId) => {
        setPermissions(prev => prev.map(p => 
            p.permissionId === permissionId ? { ...p, active: !p.active } : p
        ));
    };

    const handleSave = async () => {
        setIsSaving(true);
        console.log("Saving permissions for role:", editingRole.roleid, permissions);
        try {
            await AdminApi.updateRolePermissions(editingRole.roleid, permissions);
            alert("Lưu quyền thành công");
            clickChangeMenu('taikhoan-roles');
        } catch (err) {
            console.error("Error saving permissions:", err);
            const errorMsg = err.response?.data?.message || err.message || "Lỗi không xác định";
            alert(`Lỗi khi lưu quyền: ${errorMsg}`);
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div className="social-box" style={{ padding: '20px', backgroundColor: 'white', borderRadius: '8px', margin: '15px' }}>
            <h3 className="page-title" style={{ marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
                Sửa quyền nhóm thành viên: {editingRole?.rolename}
            </h3>
            
            <div className="body" style={{ padding: '20px' }}>
                {isLoading ? (
                    <div className="text-center">Đang tải quyền...</div>
                ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '25px', maxWidth: '500px' }}>
                        {permissions?.map(p => (
                            <div key={p.permissionId} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span style={{ fontSize: '16px', fontWeight: '500' }}>{getLabel(p.code)}</span>
                                <input 
                                    type="checkbox" 
                                    checked={p.active} 
                                    onChange={() => handleToggle(p.permissionId)}
                                    style={{ width: '20px', height: '20px' }}
                                />
                            </div>
                        ))}
                    </div>
                )}

                <div className="form-actions" style={{ marginTop: '40px', borderTop: '1px solid #eee', paddingTop: '20px' }}>
                    <button 
                        className="btn btn-primary" 
                        style={{ backgroundColor: '#5cb85c', border: 'none', padding: '8px 25px' }} 
                        onClick={handleSave}
                        disabled={isSaving}
                    >
                        {isSaving ? 'Đang lưu...' : 'Lưu'}
                    </button>
                    <button 
                        className="btn" 
                        style={{ marginLeft: '10px', padding: '8px 25px' }} 
                        onClick={() => clickChangeMenu('taikhoan-roles')}
                    >
                        Quay lại
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AdminRolePermissionEditPage;
